import { BrowserRouter } from 'react-router-dom';

import Content from './Content';
import { AuthProvider } from '@shared';
import { UserProvider } from '@shared';
import { Notifications } from '@shared';
import { ThemeProvider } from '@shared';
import { AppProvider } from '@molecules';

const App: React.FC = () => {
  return (
    <>
      <Notifications />
      <BrowserRouter>
        <ThemeProvider>
          <AuthProvider>
            <UserProvider>
              <AppProvider>
                <Content />
              </AppProvider>
            </UserProvider>
          </AuthProvider>
        </ThemeProvider>
      </BrowserRouter>
    </>
  );
};

export default App;
